// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_0CYp3 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
input._formBoxSwitch__input_ZTozW {
  margin: 0;
  width: var(--default-clickable-area);
  /* Keep it visually hidden but on the position of visual switch icon */
  position: absolute;
  inset-block: 0;
  inset-inline-end: var(--form-element-label-offset);
  z-index: -1;
  opacity: 0 !important;
  /* Override server styles */
  height: auto;
  cursor: inherit;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcFormBoxSwitch-C4cbxBBA.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,sEAAsE;EACtE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_0CYp3 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\ninput._formBoxSwitch__input_ZTozW {\n  margin: 0;\n  width: var(--default-clickable-area);\n  /* Keep it visually hidden but on the position of visual switch icon */\n  position: absolute;\n  inset-block: 0;\n  inset-inline-end: var(--form-element-label-offset);\n  z-index: -1;\n  opacity: 0 !important;\n  /* Override server styles */\n  height: auto;\n  cursor: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
